import './application';
import '../apps/country_region_trails/main.ts';
import chromeImage from '../images/browser-icon-chrome.svg';
import firefoxImage from '../images/browser-icon-firefox.svg';
import safariImage from '../images/browser-icon-safari.svg';
import edgeImage from '../images/browser-icon-edge.svg';
import operaImage from '../images/browser-icon-opera.svg';
import defaultImage from '../images/browser-icon-default.svg';
import '../utils/splide';

function detectBrowser() {
  const userAgent = navigator.userAgent;

  if (userAgent.includes("Chrome") && !userAgent.includes("Edge") && !userAgent.includes("OPR")) {
    return "chrome";
  } else if (userAgent.includes("Firefox")) {
    return "firefox";
  } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
    return "safari";
  } else if (userAgent.includes("Edge")) {
    return "edge";
  } else if (userAgent.includes("OPR")) {
    return "opera";
  } else {
    return "default";
  }
}

// Set browser icon based on detected browser
function setBrowserIcon() {
  const browser = detectBrowser();
  const browserIcon = document.getElementById("browserIcon");

  switch (browser) {
    case "chrome":
      browserIcon.src = chromeImage;
      browserIcon.alt = "Chrome Logo";
      break;
    case "firefox":
      browserIcon.src = firefoxImage;
      browserIcon.alt = "Firefox Logo";
      break;
    case "safari":
      browserIcon.src = safariImage;
      browserIcon.alt = "Safari Logo";
      break;
    case "edge":
      browserIcon.src = edgeImage;
      browserIcon.alt = "Edge Logo";
      break;
    case "opera":
      browserIcon.src = operaImage;
      browserIcon.alt = "Opera Logo";
      break;
    default:
      browserIcon.src = defaultImage;
      browserIcon.alt = "Browser Logo";
  }
}

// Function to detect mobile devices
function isMobileDevice() {
  return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

$(document).ready(function () {
  if (isMobileDevice()) {
    showModalOnFirstVisit();
  }
});
